import React from 'react';

import {
  Layout,
  SEO,
  CartContent,
  CollectionGrid,
  JustLanded,
  JustDropped,
  NewsletterSignup,
} from '../components';

function CartPage() {
  return (
    <Layout>
      <SEO title="Cart" />
      <div className="grid gap-6">
        <CartContent />
        <CollectionGrid />
        <JustLanded />
        <JustDropped />
      </div>
      <NewsletterSignup />
    </Layout>
  );
}

export default CartPage;
